//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, destroy, _TRANSACTION_TYPE, _TYPE } from '@/apis/memberAccountRecord'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                type: [],
                transactionType: [],
            },
            searchQuery: {
                name: "",
                orderId: "",
                phone: "",
                sDate: "",
                eDate: "",
                transactionType: "",
                type: "",
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '交易編號', dataIndex: 'id', key: 'id', width: 120, },
            { title: '客戶姓名', dataIndex: 'memberName', key: 'memberName', width: 150, },
            { title: '客戶手機', dataIndex: 'memberPhone', key: 'memberPhone', width: 150, },
            { title: '交易點數', key: 'pointsAmount', width: 150, scopedSlots: { customRender: 'amountSlot' }, },
            { title: '交易類型', key: 'transactionType', width: 150, scopedSlots: { customRender: 'transactionTypeSlot' }, },
            { title: '點數類型', key: 'type', width: 120, scopedSlots: { customRender: 'typeSlot' }, },
            { title: '備註', dataIndex: "transactionDesc", key: 'transactionDesc', width: 180, },

            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            // { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        moment,
        onChangeDate(value) {
            if (value.length > 0) {
                this.searchQuery.sDate = value[0].format('YYYY-MM-DD HH:mm')
                this.searchQuery.eDate = value[1].format('YYYY-MM-DD HH:mm')
            } else {
                this.searchQuery.sDate = ""; this.searchQuery.eDate = "";
            }

        },
        async onPageConfig() {
            try {

                let _type = [], _transaction_type = [];
                Object.keys(_TRANSACTION_TYPE).forEach(value => {
                    _transaction_type.push({
                        id: value,
                        name: _TRANSACTION_TYPE[value]
                    })
                })
                this.config.transactionType = _transaction_type;

                Object.keys(_TYPE).forEach(value => {
                    _type.push({
                        id: value,
                        name: _TYPE[value]
                    })
                })
                this.config.type = _type;


            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });

                this.records = this.parseRecords(res.data.records);

                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {
            records.forEach(record => {
                record.transactionTypeText = this._getTransactionTypeText(record.transactionType);
            });
            return records;
        },
        _getTransactionTypeText(value) {

            return _TRANSACTION_TYPE[value] !== undefined ? _TRANSACTION_TYPE[value] : '-';
        },
        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await destroy(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/gymnasium/${id}`);
        },
        handleToForm(id) {
            if (id > 0) {
                this.$router.push(`/activity/edit/${id}`);
            } else {
                this.$router.push('/activity/add');
            }

        }
    }
}
